<div *ngIf="schemaFinancial?.length >= 1">
    <div class="chart-container">
        <canvas  id="MyChart" >{{ chart }}</canvas>
    </div>
</div>
<p *ngIf="schemaDescription" [innerHTML]="schemaDescription | safeHtml"></p>